<template>
  <div id="DistributorSearchResults">
    <h2
      class="h2"
      v-show="!loading && distributors.length > 0"
    >
      {{ distributorSearchTitle }}
    </h2>
    <div
      class="h2"
      v-show="!(!loading && distributors.length > 0)"
    >
      {{ $tv('resultsWithoutBracket', 'distributorSearch') }}
    </div>
    <div
      class="distrubutor-search-result-list custom-scrollbar"
      :class="{ 'scrollbar-off': loading }"
    >
      <div v-if="!loading">
        <div
          v-for="distributor in distributors"
          :key="distributor.id"
        >
          <result-single
            :distributor="distributor"
            @focusOnDistributor="$emit('focusOnDistributor', distributor)"
            :distributor-selected="focussedDistributor && distributor.Id === focussedDistributor.Id"
          />
          <div class="item-seperator" />
        </div>
      </div>
      <div v-if="distributors.length === 0 && !loading">
        <div class="distributor-search-result-single">
          <div class="details no-results">
            <div
              class="address"
            >
              {{ $tv('noResults', 'distributorSearch') }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="result-list-loader"
        v-else-if="loading"
      >
        <div
          v-for="n in 10"
          :key="'DistributorSkeletonListItem' + n"
          class="skeleton-item"
        >
          <DistributorSkeletonListItem />
          <div class="item-seperator" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DistributorSearchResultSingle from './DistributorSearchResultSingle.vue'
import DistributorSkeletonListItem from './DistributorSkeletonListItem.vue'

export default {
  components: {
    'result-single': DistributorSearchResultSingle,
    DistributorSkeletonListItem
  },
  props: {
    distributors: {
      type: Array || null,
      required: false,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    focussedDistributor: {
      type: Object,
      required: false,
      default() {
        return null
      }
    }
  },
  computed: {
    distributorSearchTitle() {
      return this.$tv({messageKey: 'results', messageValues: {total: this.distributors ? this.distributors.length : 0}}, 'distributorSearch')
    }
  }
}
</script>

<style lang="scss">
[id='DistributorSearchResults'] {
  .result-list-loader {
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .skeleton-item {
    min-height: 6.25rem;
    width: 100%;
  }

  .scrollbar-off {
    overflow: hidden;
  }

  .h2 {
    background-color: $color__primary;
    font-weight: $base-text-font-weight-semi-bold;
    color: $color__white;
    padding: .75rem;
    margin: $default-margin-padding-width 0 0;
  }

  .no-results {
    div.address {
      line-height: 1.25rem;
      margin-bottom: .25rem;
    }
  }
}

.distrubutor-search-result-list {
  @include breakpoint-up($md) {
    min-height: 34.5rem;
  }

  position: relative;
  overflow-y: scroll;
  background-color: $color__white;
  max-height: 34.5rem;
  scrollbar-width: thin;
  scrollbar-color: $color__primary $color__page--background;
}

.item-seperator {
  height: .125rem;
  background-color: $color__page--background;
  width: 100%;
}

</style>
